import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BeforeJesus } from "../before-jesus/before-jesus";
import { PontiusPilate } from "../pontius-pilate/pontius-pilate";
import { Thallus } from "../thallus/thallus";
import { Paul } from "../paul/paul";
import { Josephus } from "../josephus/josephus";
import { Papias } from "../papias/papias";
import { PlinyTheYounger } from "../pliny-the-younger/pliny-the-younger";
import { Tacitus } from "../tacitus/tacitus";
import { Suetonius } from "../suetonius/suetonius";
import { Polycarp } from "../polycarp/polycarp";
import { Phlegon } from "../phlegon/phlegon";
import { Marcion } from "../marcion/marcion";
import { Gospels } from "../gospels/gospels";
import { Prophecies } from "../prophecies/prophecies";
import { Anachronisms } from "../anachronisms/anachronisms";
import { Ignatius } from "../ignatius/ignatius";
import { Didache } from "../didache/didache";
import { JustinMartyr } from "../justin-martyr/justin-martyr";
import { MaraBarSerapion } from "../mara-bar-serapion/mara-bar-serapion";
import { LucianOfSamosata } from "../lucian-of-samosata/lucian-of-samosata";
import { Clement } from "../clement/clement";
import { Celsus } from "../celsus/celsus";
import { Irenaeus } from "../irenaeus/irenaeus";
import { Tertullian } from "../tertullian/tertullian";
import { P52 } from "../p52/p52";
import { Manuscripts } from "../manuscripts/manuscripts";
import { Relics } from "../relics/relics";
import { Talmud } from "../talmud/talmud";
import { Eusebius } from "../eusebius/eusebius";
import { ShroudOfTurin } from "../shroud-of-turin/shroud-of-turin";
import { BcAd } from "../bc-ad/bc-ad";
import { Hcm } from "../hcm/hcm";
import { RonWyatt } from "../ron-wyatt/ron-wyatt";
import { Stylometry } from "../stylometry/stylometry";
import { Everything } from "../everything/everything";
import { DieForALie } from "../die-for-a-lie/die-for-a-lie";

@Component({
  selector: 'app-full',
  imports: [BeforeJesus, PontiusPilate, Thallus, Paul, Josephus, Papias, PlinyTheYounger, Tacitus, Suetonius, Polycarp, Phlegon, Marcion, Gospels, Prophecies, Anachronisms, Ignatius, Didache, JustinMartyr, MaraBarSerapion, LucianOfSamosata, Clement, Celsus, Irenaeus, Tertullian, P52, Manuscripts, Relics, Talmud, Eusebius, ShroudOfTurin, BcAd, Hcm, RonWyatt, Stylometry, Everything, DieForALie],
  templateUrl: './full.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './full.scss',
})
export class Full {
}
